module.exports = __webpack_public_path__ + "media/images/countryrect/cv-97f3bb6f5e745a202cf490927ea33cf8.svg";